module.exports = __webpack_public_path__ + "img/cover1.1a6156e5.png";